import React from 'react'
import PropTypes from 'prop-types'

import Price from './Price'
import './TLBciPrice.css'
import texts from '../../../common/texts.json'

const TLBciPrice = ({
  price, priceClass, imgClass, imgWidth, imgHeight, textClass,
}) => (
  <div className="d-flex">
    <Price price={price} className={priceClass} />
    <img className={imgClass} alt="Tarjeta Lider" src="/catalogo/images/lider-card.svg" width={imgWidth} height={imgHeight} />
    <span className={textClass}>
      {texts.PRODUCT_PRICES.LIDER_BCI_TEXT}
    </span>
  </div>
)

TLBciPrice.propTypes = {
  price: PropTypes.number.isRequired,
  priceClass: PropTypes.string,
  imgClass: PropTypes.string,
  textClass: PropTypes.string,
  imgWidth: PropTypes.number,
  imgHeight: PropTypes.number,
}

TLBciPrice.defaultProps = {
  priceClass: 'pdp-mobile-TLMC-price',
  imgClass: 'tlbci-price__img__pdp--desktop',
  textClass: 'pdp-desktop-pay',
  imgWidth: 25,
  imgHeight: 30,
}

export default TLBciPrice
